import axios, { AxiosRequestConfig } from 'axios';

import {
  AUTH_TOKEN,
  BLOB_TYPE,
  MAX_CONTENT_LENGTH,
  RESPONSE_TYPE,
  TIMEOUT,
  TIMEOUT_REPORT,
  TOKEN_HEADER,
} from '@repo/constants';

const host = import.meta.env.VITE_BACKEND_HOST;

axios.defaults.withCredentials = true;

export const instance = axios.create({
  baseURL: host,
  timeout: TIMEOUT,
  responseType: RESPONSE_TYPE,
  maxContentLength: MAX_CONTENT_LENGTH,
  withCredentials: true,
});

export const fileInstance = axios.create({
  baseURL: host,
  timeout: TIMEOUT,
  responseType: BLOB_TYPE,
  maxContentLength: MAX_CONTENT_LENGTH,
  withCredentials: true,
});

export const reportInstance = axios.create({
  baseURL: host,
  timeout: TIMEOUT_REPORT,
  responseType: RESPONSE_TYPE,
  maxContentLength: MAX_CONTENT_LENGTH,
  withCredentials: true,
});

export function makeRequest(
  type: AxiosRequestConfig['method'],
  path: string,
  body?: AxiosRequestConfig['data'],
) {
  console.log(instance);
  axios.defaults.headers.common['Authorization'] =
    TOKEN_HEADER + (localStorage.getItem(AUTH_TOKEN) ?? '');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  return instance[type](path, body);
}

export function makeFileRequest(
  type: AxiosRequestConfig['method'],
  path: string,
  body?: AxiosRequestConfig['data'],
) {
  axios.defaults.headers.common['Authorization'] =
    TOKEN_HEADER + (localStorage.getItem(AUTH_TOKEN) ?? '');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  return fileInstance[type](path, body);
}

export function makeReportRequest(
  type: AxiosRequestConfig['method'],
  path: string,
  body?: AxiosRequestConfig['data'],
) {
  axios.defaults.headers.common['Authorization'] =
    TOKEN_HEADER + (localStorage.getItem(AUTH_TOKEN) ?? '');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  return reportInstance[type](path, body);
}

instance.interceptors.request.use(
  function (config) {
    if (config.headers.common.Authorization.trim() === 'Bearer') {
      config.headers.common.Authorization = '';
    }
    console.log(config.headers);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    return Promise.resolve(response.data);
  },
  function (error) {
    if (error.response && error.response.status) {
      const statusCode = String(error.response.status);
      if (statusCode === '401') {
        if (window.location.pathname !== '/auth/login') {
          window.location.href = '/auth/login';
        }
        localStorage.removeItem(AUTH_TOKEN);
      } else if (statusCode.startsWith('4') || statusCode.startsWith('5')) {
        return Promise.reject(error);
      } else {
        return Promise.resolve(error.response.data);
      }
    } else {
      error.message = 'Network Connection Error';
      return Promise.reject(error);
    }
  },
);
